var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"home"},[_c('v-card-title',{staticClass:"d-flex justify-center h-100 pa-0"},[_c('iframe',{attrs:{"src":"https://dashboard.spedimo.eu/spedilink/","width":"100%","height":"100%","frameBorder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }